var exports = {
  "XG": "ChannelAttachmentArea.module__scroller___VTJ0U0",
  "IP": "ChannelAttachmentArea.module__channelAttachmentArea___VTJ0U0",
  "Se": "ChannelAttachmentArea.module__upload___VTJ0U0",
  "PO": "ChannelAttachmentArea.module__uploadContainer___VTJ0U0",
  "il": "ChannelAttachmentArea.module__mediaContainer___VTJ0U0",
  "BA": "ChannelAttachmentArea.module__clickableMedia___VTJ0U0",
  "q2": "ChannelAttachmentArea.module__spoilerContainer___VTJ0U0",
  "R": "ChannelAttachmentArea.module__hidden___VTJ0U0",
  "rP": "ChannelAttachmentArea.module__hiddenSpoiler___VTJ0U0",
  "pR": "ChannelAttachmentArea.module__spoilerWarning___VTJ0U0",
  "Qx": "ChannelAttachmentArea.module__obscureWarning___VTJ0U0",
  "Qu": "ChannelAttachmentArea.module__spoilerInnerContainer___VTJ0U0",
  "CU": "ChannelAttachmentArea.module__spoilerWrapper___VTJ0U0",
  "p6": "ChannelAttachmentArea.module__spoiler___VTJ0U0",
  "$_": "ChannelAttachmentArea.module__media___VTJ0U0",
  "_A": "ChannelAttachmentArea.module__tags___VTJ0U0",
  "H6": "ChannelAttachmentArea.module__filenameContainer___VTJ0U0",
  "iW": "ChannelAttachmentArea.module__filename___VTJ0U0",
  "VF": "ChannelAttachmentArea.module__fileDetails___VTJ0U0",
  "Ov": "ChannelAttachmentArea.module__fileSize___VTJ0U0",
  "i_": "ChannelAttachmentArea.module__fileExtension___VTJ0U0",
  "TC": "ChannelAttachmentArea.module__actionBarContainer___VTJ0U0",
  "KY": "ChannelAttachmentArea.module__actionBar___VTJ0U0" + " " + __webpack_require__(180357)["KE"],
  "x6": "ChannelAttachmentArea.module__button___VTJ0U0" + " " + __webpack_require__(180357)["AS"],
  "OR": "ChannelAttachmentArea.module__danger___VTJ0U0",
  "le": "ChannelAttachmentArea.module__actionBarIcon___VTJ0U0",
  "s3": "ChannelAttachmentArea.module__altTag___VTJ0U0",
  "Kk": "ChannelAttachmentArea.module__icon___VTJ0U0",
  "Dp": "ChannelAttachmentArea.module__iconImage___VTJ0U0",
  "t0": "ChannelAttachmentArea.module__spin___VTJ0U0",
  "vt": "ChannelAttachmentArea.module__videoModal___VTJ0U0",
  "j": "ChannelAttachmentArea.module__videoContainer___VTJ0U0",
  "yF": "ChannelAttachmentArea.module__divider___VTJ0U0",
  "mg": "ChannelAttachmentArea.module__dropIndicatorLeft___VTJ0U0",
  "l_": "ChannelAttachmentArea.module__dropIndicatorRight___VTJ0U0",
};

module.exports = exports;
